import { AppRoutes } from 'enums/routes.enum';
import { useUserStore } from 'providers/RootStoreProvider';
import { ampli } from 'services/ampli';
import { removeTokensFromStorage } from 'services/storage';
import { supabase } from 'services/supabase';
import { useCallback } from 'react';

export const useLogout = () => {
    const { setUser, setUserProfile } = useUserStore();

    const logout = useCallback(() => {
        supabase.auth
            .signOut()
            .then(() => {
                if (ampli.isLoaded) {
                    ampli.accountLogoutClicked();
                }

                setUser(null);
                setUserProfile(null);
                removeTokensFromStorage();

                window.location.assign(AppRoutes.LOG_IN);
            })
            .catch((error) => {
                console.error('error: ', error);
            });

        localStorage.setItem('existingUserLoggedOut', 'true');
    }, []);

    return logout;
};
